// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { connect } from 'react-redux';
import { toggleModal } from '../../storage/actions/modalsActions';
import AddOrEditUsersForManagementReduxForm from '../layout/reduxForm/AddOrEditUsersForManagementReduxForm';
import initialValues from '../../utils/reduxForm/InitialValues/addOrEditUsersForUserManagement';
import handleSubmit from '../../utils/reduxForm/onSubmit/addOrEditUsersForUserManagement';

const AddOrEditUsersForManagement = ({ modalState, toggleModal }) => {
  const typeData = modalState.type && typeof modalState.type === 'object'
    ? modalState.type
    : {};
  const isEdit = !!(typeData.id || typeData._id);

  const closeModal = () => {
    toggleModal(false, 'addOrEditUsersForManagement');
  };

  if (!modalState.isOpen) {
    return null;
  }

  const formInitialValues = isEdit
    ? {
      ...initialValues,
      firstName: typeData.firstName || '',
      lastName: typeData.lastName || '',
      email: typeData.email || '',
      phone: typeData.phone || '',
      role: typeData.role || '',
      id: typeData.id || typeData._id,
      _id: typeData._id || typeData.id,
      companyId: typeData.companyId,
      status: typeData.status,
    }
    : initialValues;

  return (
    <div className="popup_block dashboard-modal showed">
      <div className="popup_container">
        <div className="popup_head">
          <div className="popup_title">{isEdit ? 'Edit user' : 'Add user'}</div>
          <button type="button" className="close_btn" aria-label="close" onClick={closeModal}>
            ×
          </button>
        </div>
        <AddOrEditUsersForManagementReduxForm
          initialValues={formInitialValues}
          onSubmit={handleSubmit}
          closeModal={closeModal}
        />
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  modalState: state.modalState.addOrEditUsersForManagement,
});

export default connect(mapStateToProps, { toggleModal })(AddOrEditUsersForManagement);
